module.exports = __webpack_public_path__ + "media/images/ui-icons_777620_256x240-2487f1f6cffd2524ad3c4b8626540a04.png";